import { appServiceClient } from '@/infrastructure/http/httpClient';

import {
  IAgenteRespostaResult,
  IConfirmarResult,
  IConversaView,
  ISaudeResult,
  IScreenContext,
} from '../interfaces/agente';

class AgenteRepository {
  async mensagem(texto: string, contexto: IScreenContext): Promise<IAgenteRespostaResult> {
    return appServiceClient.post<IAgenteRespostaResult>('agente/mensagem', { body: { texto, contexto } });
  }

  async confirmar(propostaId: string): Promise<IConfirmarResult> {
    return appServiceClient.post<IConfirmarResult>('agente/confirmar', { body: { propostaId } });
  }

  async getConversa(): Promise<IConversaView> {
    return appServiceClient.get<IConversaView>('agente/conversa');
  }

  async limparConversa(): Promise<void> {
    return appServiceClient.delete<void>('agente/conversa');
  }

  async saude(): Promise<ISaudeResult> {
    return appServiceClient.get<ISaudeResult>('agente/saude');
  }
}

export const agenteRepository = new AgenteRepository();
